import { Box } from '@mui/material';
import PropTypes from 'prop-types';

function AvatarBubble({
  color, Icon, sx, size,
}) {
  const reduce = ['small-medium', 'small'];
  return (
    <Box
      sx={{
        position: 'absolute',
        boxShadow: '0 0 1px 0 rgb(0 0 0 / 50%)',
        borderRadius: '50%',
        width: reduce.includes(size) ? 14 : 20,
        height: reduce.includes(size) ? 14 : 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Icon
        color={color}
        sx={{
          color: color === undefined ? '#fff' : null,
          width: reduce.includes(size) ? 10 : 14,
          height: reduce.includes(size) ? 10 : 14,
        }}
      />
    </Box>
  );
}

AvatarBubble.defaultProps = {
  color: undefined,
  sx: {},
  size: null,
};

AvatarBubble.propTypes = {
  color: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.elementType,
    PropTypes.shape({}),
  ]).isRequired,
  sx: PropTypes.shape({}),
  size: PropTypes.string,
};

export default AvatarBubble;
